export default __webpack_public_path__ + "static/media/male.82242d54.png";